var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-l-token"},[_c('span',{staticClass:"gb-l-token-text"},[_c('b',[_vm._v(_vm._s(_vm.$t('downloads.yourToken'))+" ")]),_c('br'),_vm._v(" "+_vm._s(_vm.legacyToken == null ? 'Loading token...' : _vm.legacyToken)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }